module.exports = __webpack_public_path__ + "static/media/user_avatar.7bf07f5c.png";